import { getUserConfiguration } from 'owa-session-store';
export default function isMessagePreviewEnabled() {
    return getUserConfiguration().UserOptions.ShowPreviewTextInListView;
}
//# sourceMappingURL=isMessagePreviewEnabled.js.map